<template>
    <b-modal
    v-model="showModal"
    size="md"
    hide-footer
    centered
    header-class="ApplicationEditModalHeaderVariant"
    header-text-variant="white"
    :no-close-on-backdrop="true"
    :title=title
    v-bind="setInfo(substituteHolidayInfo)"
    @shown="changeDate(substituteHolidayInfo.date)"
    >
      <template v-slot:default>
        <div>
          <b-form-group class="d-flex" id="input-date-live-feedback" :invalid-feedback="messageHourState" :state="isDateState">
          <!-- <b-form-group class="d-flex"> -->
            <!-- 日付 -->
            <div class="WorkM_InputGroupArea">
              <div class="WorkM_InputGroup_ItemLabel">日付</div>
                <div class="d-flex">
                  <b-form-datepicker 
                  v-model="rewriteDate" 
                  @input="changeDate"
                  :date-format-options="{ 
                  year: 'numeric', 
                  month: '2-digit', 
                  day: '2-digit', 
                  weekday: 'short' 
                  }" 
                  size="sm"
                  placeholder="YYYY/MM/DD"
                  aria-describedby="input-date-live-feedback"
                  ></b-form-datepicker>
                  <div v-if="!emptyCheck(rewriteDateTypeStr)" style="white-space: nowrap;" class="my-auto">
                    {{ "（" + rewriteDateTypeStr + "）" }}
                  </div>
                </div>
            </div>
          </b-form-group>
          <!-- 時間 -->
          <b-form-group id="input-time-live-feedback" :invalid-feedback="messageHourState" :state="isHourState">
            <div class="d-flex mt-3">
              <div class="WorkM_InputGroupArea">
                <div class="WorkM_InputGroup_ItemLabel">時間 from</div>
                <div class="WorkM_InputTimeGroup">
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="optionTimeHour" v-model="rewriteStartHour" @change="timeState"></b-select>
                  </div>
                  <div class="mx-1">:</div>
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="setOptionStartTimeMin" v-model="rewriteStartMin" @change="timeState"></b-select>
                  </div>
                </div>
              </div>

              <div class="WorkM_InputGroupArea ml-3">
                <div class="WorkM_InputGroup_ItemLabel">時間 to</div>
                <div class="WorkM_InputTimeGroup">
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="optionTimeHour" v-model="rewriteEndHour" @change="timeState"></b-select>
                  </div>

                  <div class="mx-1">:</div>
                  <div class="WorkM_InputTimeGroup_InputItem">
                    <b-select size="sm" aria-describedby="input-time-live-feedback" :options="setOptionEndTimeMin" v-model="rewriteEndMin" @change="timeState"></b-select>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="mt-4">
          <div class="d-flex justify-content-between flex-row-reverse">
            <div class="WorkM_Button WorkM_ButtonSuccess" @click="setSubstituteHoliday">確定</div>
          </div>
        </div>
      </template>
    </b-modal>
</template>

<script>
import config from "../../const/config";
export default{
  name: "InputSubstitudeHolidayModal",
  props: {
    title:{type: String, default: "振休希望日入力"},
    loginUserId: { type: Number, default: 0 },
    substituteHolidayInfo: {
      type: Object,
      default: () => {}
    },
  },
  data: function(){
    return{
      isHourState: null,
      isDateState: false,
      showModal: false,
      rewriteDate:null,
      rewriteDateType:null,
      rewriteDateTypeStr:null,
      rewriteStartHour: 0,
      rewriteStartMin: 0,
      rewriteEndHour: 0,
      rewriteEndMin: 0,
      optionTimeHour: [
        { value: 0, text: "00" },
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
      ],
      optionTimeMin: [
        { value: 0, text: "00" },
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
        { value: 25, text: "25" },
        { value: 26, text: "26" },
        { value: 27, text: "27" },
        { value: 28, text: "28" },
        { value: 29, text: "29" },
        { value: 30, text: "30" },
        { value: 31, text: "31" },
        { value: 32, text: "32" },
        { value: 33, text: "33" },
        { value: 34, text: "34" },
        { value: 35, text: "35" },
        { value: 36, text: "36" },
        { value: 37, text: "37" },
        { value: 38, text: "38" },
        { value: 39, text: "39" },
        { value: 40, text: "40" },
        { value: 41, text: "41" },
        { value: 42, text: "42" },
        { value: 43, text: "43" },
        { value: 44, text: "44" },
        { value: 45, text: "45" },
        { value: 46, text: "46" },
        { value: 47, text: "47" },
        { value: 48, text: "48" },
        { value: 49, text: "49" },
        { value: 50, text: "50" },
        { value: 51, text: "51" },
        { value: 52, text: "52" },
        { value: 53, text: "53" },
        { value: 54, text: "54" },
        { value: 55, text: "55" },
        { value: 56, text: "56" },
        { value: 57, text: "57" },
        { value: 58, text: "58" },
        { value: 59, text: "59" },
      ],
      messageHourState: '平日を選択してください',
      messageDateState: null,
    }
  },
  computed:{
    setOptionStartTimeMin: function(){
      if(this.rewriteStartHour == 24){
        this.setStartTimeMin(0);
        return [{ value: 0, text: "00" }];
      }
      else{
        return this.optionTimeMin;
      }
    },
    setOptionEndTimeMin: function(){
      if(this.rewriteEndHour == 24){
        this.setEndTimeMin(0);
        return [{ value: 0, text: "00" }]
      }
      else{
        return this.optionTimeMin;
      }
    }
  },
  mounted: function(){},
  methods:{
    openModal: function(){
      this.messageHourState = null;
      this.showModal = true;
    },
    handleOk: function () {
      // 初期表示フラグをfalseにする
      this.isInitialDisplay = false;
      this.showModal = false;
      this.$emit("handleOk");
    },
    setInfo: function(substituteWorkInfo){
      this.rewriteDate = this.getStrDateHyphen(substituteWorkInfo.date);
      let [timeStartHourStr, timeStartMinStr] = [0,0]
      let [timeEndHourStr, timeEndMinStr]= [0,0]
      if(!this.emptyCheck(substituteWorkInfo.start)){
        [timeStartHourStr, timeStartMinStr] = substituteWorkInfo.start?.split(':');
      }
      if(!this.emptyCheck(substituteWorkInfo.end)){
        [timeEndHourStr, timeEndMinStr] = substituteWorkInfo.end?.split(':');
      }
      this.rewriteStartHour = parseInt(timeStartHourStr);
      this.rewriteStartMin = parseInt(timeStartMinStr);
      this.rewriteEndHour = parseInt(timeEndHourStr);
      this.rewriteEndMin = parseInt(timeEndMinStr);
    },
    setSubstituteHoliday: function(){
      let isValidDate = this.dateState();
      if(!isValidDate){
        return;
      }
      let isValidTime = this.timeState();
      if(isValidTime == null){
        isValidTime = true;
      }
      if(!isValidTime){
        return;
      }
      let setSubstituteHoliday = {
        date:this.rewriteDate,
        start:this.optionTimeHour[this.rewriteStartHour].text + ":" + this.optionTimeMin[this.rewriteStartMin].text,
        end:this.optionTimeHour[this.rewriteEndHour].text + ":" + this.optionTimeMin[this.rewriteEndMin].text
      };
      console.log("setSubstituteHoliday：" + JSON.stringify(setSubstituteHoliday));
      this.$emit("setSubstituteHoliday",setSubstituteHoliday);
      this.showModal = false;
      this.$emit("handleOk");
    },
    setStartTimeMin(min){
      this.rewriteStartMin = min;
    },
    setEndTimeMin(min){
      this.rewriteEndMin = min;
    },
    timeState() {
      const MSG_ERR_TIME_REVERCE = "入力時間が逆転しています。";
      const MSG_ERR_TIME_EMPTY = "時間を入力してください。";
      const MSG_ERR_TIME_SAME = "FromとToに同じ時間が入力されています。"

      // 時間入力欄の内一つでも値が入っていないならメッセージを表示
      if(isNaN(this.rewriteStartHour) || isNaN(this.rewriteStartMin) || isNaN(this.rewriteEndHour) || isNaN(this.rewriteEndMin)){
        console.log(MSG_ERR_TIME_EMPTY);
        this.messageHourState = MSG_ERR_TIME_EMPTY;
        this.isHourState = false;
        return this.isHourState;
      }

      // 入力された時間のToがFromよりも小さい値ならメッセージを表示
      if(this.rewriteStartHour > this.rewriteEndHour){
        this.messageHourState = MSG_ERR_TIME_REVERCE;
        this.isHourState = false;
      }
      else if(this.rewriteStartHour == this.rewriteEndHour){
        if(this.rewriteStartMin > this.rewriteEndMin){
          this.messageHourState = MSG_ERR_TIME_REVERCE;
          this.isHourState = false;
        }
        else if(this.rewriteStartMin == this.rewriteEndMin){
          this.messageHourState = MSG_ERR_TIME_SAME;
          this.isHourState = false;
        }
        else{
          this.isHourState = null;
        }
      }
      else{
          this.isHourState = null;
      }
      return this.isHourState;
    },
    dateState(){
      const ORIDINARY_DAYS = 0;
      const MSG_ERR_NOT_ORIDINARY_DAYS = "平日以外を選択することはできません。";
      // 時間入力欄の内一つでも値が入っていないならメッセージを表示
      if(this.rewriteDateType != ORIDINARY_DAYS){
        
        this.messageHourState = MSG_ERR_NOT_ORIDINARY_DAYS;
        this.isDateState = false;
        return this.isDateState;
      }
      else{
          this.isDateState = true;
      }
      return this.isDateState;
    },
    // 変更した日付が「平日」、「休日」、「公休」かを取得
    changeDate: function(date){
      let paramList = {
          shainCd: this.loginUserId,
          targetDate: this.getStrDateSlash(date),
      }
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.USER_INFO_DATE_TYPE, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.isErrorGetShfitFlg = false;
            this.rewriteDateType = response.container.dayInfo.dateTypeCode;
            this.rewriteDateTypeStr = response.container.dayInfo.dateType;
          }
          else{
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
          this.dateState();
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    }
  },
};
</script>
<style>
.WorkM_ApplicationEditSummaryArea {
  background:rgb(238, 238, 238)!important;
  border-color: rgb(206, 212, 218) !important;
  padding: 0.3rem;
  width: 35%;
  height: auto;
}
.WorkM_InputGroup_ItemLabel {
  font-size: 0.85rem;
  color: rgb(13, 91, 136);
  font-weight: 700;
  margin: 0;
}
.WorkM_InputTimeGroup {
  display: flex;
}
.WorkM_InputTimeGroup_InputItem {
  width: 4rem;
}
.ApplicationEditModalHeaderVariant {
  /* background-color:rgb(160, 44, 44); */
  background-color:rgb(128, 00, 128);
}
</style>